import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import classnames from 'classnames';
import {Link} from 'react-router';

export const TAB_ADD = 'TAB_ADD';
export const TAB_UPLOAD = 'TAB_UPLOAD';

export default createReactClass({
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
    heading: PropTypes.string.isRequired,
    headingIcon: PropTypes.string,
    showUpload: PropTypes.bool,
    onTabChanged: PropTypes.func,
    donePath: PropTypes.string,
  },

  mixins: [ImmutableRenderMixin],

  getDefaultProps() {
    return {
      headingIcon: 'ficon-plus-circle',
      showUpload: false,
      onTabChanged: () => {},
      donePath: null,
    };
  },

  handleAllIconSetsClicked(event, tab) {
    event.preventDefault();

    this.props.onTabChanged(TAB_ADD);
  },

  handleUploadAnIconClicked(event) {
    event.preventDefault();

    this.props.onTabChanged(TAB_UPLOAD);
  },

  render() {
    const {heading, headingIcon, donePath, showUpload} = this.props;
    const headingIconClassName = classnames('ficon', headingIcon);

    let doneElement = null;
    let navElement = <hr className="hr-lg m-xs-b-lg" />;
    let uploadElement = null;

    if (donePath) {
      doneElement = (
        <div className="gg-col text-xs-right">
          <Link to={donePath} className="btn btn-secondary btn-lg">Done Adding</Link>
        </div>
      );
    }

    if (this.props.children) {
      navElement = (
        <ul className="nav nav-tabs-inline">
          {this.props.children}
        </ul>
      );
    }

    if (showUpload) {
      uploadElement = (
        <div className="gg-col text-xs-right">
          <span className="label label-info text-sm p-xs-x-md p-xs-y-sm m-xs-b-sm">
            <i className="ficon ficon-uploaded ficon-lg m-xs-r-xs"></i> Uploaded
          </span>
        </div>
      );
    }

    return (
      <div>
        <div className="gg gg-bottom m-xs-b-md">
          <div className="gg-col">
            <h2 className="m-xs-t-sm m-xs-b-0"><i className={headingIconClassName}></i>&thinsp; {heading}</h2>
          </div>
          {uploadElement}
          {doneElement}
        </div>
        {navElement}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/Header.js